export enum BulkChaseAction {
  MoveChase = "moveChase",
  OpenPrintProvider = "openPrintProvider",
  OpenOutReachModal = "openOutReachModal",
  AssignChases = "assignChases",
  OpenPendModal = "openPendModal",
  OpenManageTagModal = "openManageTagModal",
  OpenCommitmentDateModal = "openCommitmentDateModal",
  OpenChangeRetrieverModal = "openChangeRetrieverModal",
}
